export default function SocialProof() {
  const pillars = [
    {
      number: '01',
      tag: 'Quality Upheld',
      title: 'No Shortcut Goes Unnoticed',
      body: 'We’re on-site every month, documenting the production in action. You see what’s happening, in real time, and can act on it, ensuring your brand stays in control.&nbsp;',
      image: 'https://public.readdy.ai/ai/img_res/d47d1567649817dc5d2ee356511078ec.jpg',
      imageAlt: 'Clean fabric rolls in a well-lit textile factory',
      reverse: false,
    },
    {
      number: '02',
      tag: 'Ethical Responsibility',
      title: 'Due Diligence You Can Prove',
      body: 'Modern Slavery and safety risks are real in any supply chain. Monthly video reports and documented visits give you a verifiable record, you see what’s happening and can demonstrate your brand is taking responsibility.',
      image: 'https://readdy.ai/api/search-image?query=bright%20transparent%20textile%20factory%20floor%20showing%20workers%20at%20well-lit%20workstations%2C%20safety%20signage%20visible%2C%20open%20and%20organized%20workspace%2C%20ethical%20manufacturing%20environment%2C%20documentary%20photography%20style%2C%20warm%20industrial%20lighting%2C%20sense%20of%20transparency%20and%20accountability&width=800&height=560&seq=eth02&orientation=landscape',
      imageAlt: 'Transparent and well-lit factory floor showing ethical working conditions',
      reverse: true,
    },
    {
      number: '03',
      tag: 'Power of Presence',
      title: 'Insights You Can Share',
      body: 'Monthly documentation gives you more than oversight; behind-the-scenes footage you can use internally, with stakeholders, or on social media, showing your brand takes responsibility and stays in control.',
      image: 'https://readdy.ai/api/search-image?query=close-up%20of%20a%20golden%20fabric%20sample%20being%20carefully%20inspected%20under%20bright%20light%20by%20professional%20hands%2C%20high-end%20textile%20quality%20control%2C%20warm%20golden%20tones%2C%20clean%20white%20inspection%20table%2C%20sharp%20focus%20on%20fabric%20detail%2C%20premium%20fashion%20manufacturing%2C%20elegant%20and%20precise&width=800&height=560&seq=pres03&orientation=landscape',
      imageAlt: 'Golden sample being inspected for quality assurance',
      reverse: false,
    },
  ];

  return (
    <section className="py-28 bg-[#F5F0E6]">
      <div className="max-w-6xl mx-auto px-6 lg:px-16">

        {/* Header */}
        <div className="mb-20 max-w-2xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-8 h-[1px] bg-[#D98C74]"></span>
            <span className="text-[#D98C74] text-[11px] font-semibold tracking-[0.22em] uppercase">
              &nbsp;Why We’re on the Ground
            </span>
          </div>
          <h2
            className="text-[30px] lg:text-[42px] font-bold text-[#2C3E50] leading-[1.2] mb-5"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Because Someone Has To Be There
          </h2>
        </div>

        {/* Pillars */}
        <div className="flex flex-col gap-24">
          {pillars.map((pillar) => (
            <div
              key={pillar.number}
              className={`flex flex-col ${pillar.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-12 lg:gap-16 items-center`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2 flex-shrink-0">
                <div className="w-full h-[320px] lg:h-[380px] rounded-lg overflow-hidden">
                  <img
                    src={pillar.image}
                    alt={pillar.imageAlt}
                    className="w-full h-full object-cover object-top"
                    style={{ filter: 'saturate(0.75) brightness(1.05)' }}
                  />
                </div>
              </div>

              {/* Text */}
              <div className="w-full lg:w-1/2">
                <span
                  className="text-[#D98C74]/25 text-[72px] font-bold leading-none select-none block mb-2"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {pillar.number}
                </span>
                <div className="inline-flex items-center gap-2 mb-4">
                  <span className="w-5 h-[1px] bg-[#8A9A5B]"></span>
                  <span className="text-[#8A9A5B] text-[11px] font-semibold tracking-[0.2em] uppercase">
                    {pillar.tag}
                  </span>
                </div>
                <h3
                  className="text-[22px] lg:text-[28px] font-bold text-[#2C3E50] leading-[1.25] mb-5"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {pillar.title}
                </h3>
                <p className="text-[#2C3E50]/65 text-[15px] leading-[1.9]">
                  {pillar.body}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Closing Quote */}
        <div className="mt-24 border-t border-[#2C3E50]/10 pt-16 text-center max-w-3xl mx-auto">
          <p
            className="text-[#2C3E50]/70 text-[16px] lg:text-[18px] leading-[1.85] italic"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            "Paperwork can be perfected, but the factory floor doesn't lie. I act as a bridge for Western brands who need to know their ethical standards are being met in practice, not just on a signed contract."
          </p>
        </div>

      </div>
    </section>
  );
}
